import React from 'react';
import { motion } from 'framer-motion';
export function PlatformIntro() {
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center" data-id="element-446">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} data-id="element-447">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-ink-dark mb-10 leading-tight" data-id="element-448">
          One platform. Multiple layers of capability development.
        </h2>

        <div className="space-y-8 text-lg text-ink-muted leading-relaxed text-left md:text-center" data-id="element-449">
          <p data-id="element-450">
            Modern societies depend on judgment at every level, yet most systems
            are still built to sort, react, and credential rather than
            deliberately strengthen how people think, decide, adapt, and lead.
            SyNeural was built to address that problem through a unified
            platform structure that supports human development, institutional
            readiness, civic resilience, and leadership qualification.
          </p>

          <p data-id="element-451">
            At the center of the ecosystem is the{' '}
            <strong className="text-navy font-semibold" data-id="element-452">
              Civic Judgment Index (CJI)
            </strong>
            , the core platform for decision-quality analytics,
            propaganda-resistance profiling, cognitive assessment, and
            leadership reasoning diagnostics. Built within that framework is the{' '}
            <strong className="text-teal font-semibold" data-id="element-453">
              Neurocognitive Civic Judgment Index (NCJI)
            </strong>
            , a broader and deeper architecture that extends into human
            opportunity and development, lifecycle capability-building,
            public-sector readiness, and executive-level leadership evaluation.
          </p>
        </div>

        <div className="mt-12 pt-8 border-t border-line inline-block" data-id="element-454">
          <p className="text-xl font-heading font-bold text-navy-light" data-id="element-455">
            This is not a static score. It is a progression system designed to
            help people and institutions move forward.
          </p>
        </div>
      </motion.div>
    </section>;
}